import React from 'react';
import cn from 'classnames';
import { map } from 'lodash';

import './Tabs.scss';

interface Props {
    activeTab: any;
    data: {
        [value: string]: string;
    };
    changeActiveTab: (activeTab: any) => void;
    disabledTabs?: any[];
    extraTab?: JSX.Element;
}

const Tabs: React.FC<Props> = ({
    data,
    changeActiveTab,
    activeTab,
    disabledTabs,
    extraTab,
}) => {
    return (
        <div styleName="tabs" className="__app-Tabs-tabs ">
            {map(data, (title, value) => {
                const isActive = activeTab === value;
                const isDisabled =
                    !!disabledTabs && disabledTabs.includes(value);

                const handleChooseTab =
                    !isActive && !isDisabled
                        ? changeActiveTab.bind(this, value)
                        : undefined;

                const tabState = {
                    isActive,
                    isDisabled,
                };

                return (
                    <div
                        className={getStyleNames({
                            ...tabState,
                            prefix: '__app-Tabs-',
                        })}
                        styleName={getStyleNames({
                            ...tabState,
                        })}
                        onClick={handleChooseTab}
                        key={value}
                    >
                        {title}
                    </div>
                );
            })}
            {extraTab}
        </div>
    );
};

interface GetStyleOptions {
    isActive: boolean;
    isDisabled: boolean;
    prefix?: string;
}

function getStyleNames({
    isActive,
    isDisabled,
    prefix = '',
}: GetStyleOptions): string {
    return cn(`${prefix}tab`, {
        [`${prefix}is-active`]: isActive,
        [`${prefix}is-disabled`]: isDisabled,
    });
}

export default Tabs;
